import "./Pagination.css";

function PaginationButton({ children, selected = false, onClick }) {
    return (
        <div
            className={`paginationButton ${selected ? 'paginationButtonSelected' : ''}`}
            onClick={onClick}
        >
            <div className={`paginationTypo ${selected ? 'paginationTextSelected' : 'paginationTextNormal'}`}>
                {children}
            </div>
        </div>
    );
}

function constructPagination(currentPage, total) {
    if (total <= 6) {
        return Array(total).fill(0).map((_, i) => String(i + 1));
    } else {
        if (currentPage <= 3) {
            return ["1", "2", "3", "4", "...", String(total)];
        } else if (currentPage >= total - 3) {
            return ["1", "...", String(total - 3), String(total - 2), String(total - 1), String(total)];
        } else {
            return ["1", "...", String(currentPage - 1), String(currentPage), String(currentPage + 1), "...", String(total)];
        }
    }
}

export function GalleryPagination({ currentPage, total, onPageChange }) {
    const pagination = constructPagination(currentPage, total);

    const handleClick = (item) => {
        if (item === "...") return;
        const pageNum = parseInt(item);
        if (!isNaN(pageNum) && onPageChange) {
            onPageChange(pageNum);
        }
    };

    const handlePrev = () => {
        if (currentPage > 1 && onPageChange) {
            onPageChange(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < total && onPageChange) {
            onPageChange(currentPage + 1);
        }
    };

    return (
        <div className="paginationBar">
            <div
                className={`paginationArrow ${currentPage === 1 ? 'paginationArrowDisabled' : ''}`}
                onClick={handlePrev}
            >
                <img src={`${process.env.PUBLIC_URL}/back.svg`} alt="Previous" />
            </div>
            {pagination.map((item, index) => (
                <PaginationButton
                    key={index}
                    selected={item === String(currentPage)}
                    onClick={() => handleClick(item)}
                >
                    {item}
                </PaginationButton>
            ))}
            <div
                className={`paginationArrow ${currentPage === total ? 'paginationArrowDisabled' : ''}`}
                onClick={handleNext}
            >
                <img src={`${process.env.PUBLIC_URL}/forward.svg`} alt="Next" />
            </div>
        </div>
    );
}
